export default __webpack_public_path__ + "static/media/H0000.e9066d60.png";